import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';

import {
  LeafAuthGuardModule, LeafAuthGuardService,
} from '@input-output-labs/ngleaf';
import { MainLayoutComponent } from 'component/main-layout/main-layout.component';
import { MainLayoutModule } from 'component/main-layout/main-layout.module';

const routes: Route[] = [
  {
    path: 'welcome',
    loadChildren: () => import('./welcome/welcome.module').then(m => m.WelcomeModule)
  },
  {
    path: '',
    canActivate: [LeafAuthGuardService],
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'character-sheets',
        pathMatch: 'full',
      },
      {
        path: 'character-sheets',
        loadChildren: () => import('./character-sheets/character-sheets.module').then(m => m.CharacterSheetsModule)
      },
      {
        path: 'settings',
        loadChildren: () => import('./account-settings/account-settings.module').then(m => m.AccountSettingsModule)
      },
      {
        path: 'admin/workspace-settings',
        loadChildren: () => import('./admin/workspace-settings/workspace-settings.module').then(m => m.WorkspaceSettingsModule)
      },
    ]
  },
  {
    path: '**',
    redirectTo: 'character-sheets',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    LeafAuthGuardModule,
    MainLayoutModule,
  ],
  exports: [RouterModule],
})
export class AppRouteModule {}

